// api timestamps can come back without a timezone, and they're always utc
const parseApiDate = (date: string): Date => {
  const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(date)
  return new Date(hasTimezone ? date : `${date}Z`)
}

export const formatTimeAgo = (date: string, now: number = Date.now()): string => {
  const seconds = Math.max(0, Math.floor((now - parseApiDate(date).getTime()) / 1000))
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  return `${Math.floor(hours / 24)}d ago`
}

export const sortByNewest = <T extends { insertedAt: string }>(items: T[]): T[] => {
  return [...items].sort((a, b) => parseApiDate(b.insertedAt).getTime() - parseApiDate(a.insertedAt).getTime())
}
